import { render, staticRenderFns } from "./ProjectPausedLifecycleSetter.vue?vue&type=template&id=51716021"
import script from "./ProjectPausedLifecycleSetter.vue?vue&type=script&lang=ts"
export * from "./ProjectPausedLifecycleSetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports